// NOT YET TESTED
import {Component, ElementRef, Input, ViewChild} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {COMMA, ENTER} from "@angular/cdk/keycodes";
import {Observable} from "rxjs";
import {map, startWith} from "rxjs/operators";

@Component({
  selector: 'app-tag-file',
  templateUrl: './tag-file.component.html',
  styleUrls: ['./tag-file.component.scss']
})

export class TagFileComponent {
  @Input() formGroupParent: FormGroup;
  @Input() formName: string;
  @Input() formArray: string[];

  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  item: string[] = [];

  @ViewChild('itemInput') fruitInput: ElementRef<HTMLInputElement>;

  constructor() {

  }
}
